const SMOOTH_DURATION = 500

export { SMOOTH_DURATION }
